/**
 * @generated SignedSource<<4925e669c2493ff83dc8548b9d9d63b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsModal_viewer$data = {
  readonly currencies: ReadonlyArray<string | null> | null;
  readonly intlMvpEnabled: boolean | null;
  readonly " $fragmentType": "DisplaySettingsModal_viewer";
};
export type DisplaySettingsModal_viewer$key = {
  readonly " $data"?: DisplaySettingsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencies",
      "storageKey": null
    },
    {
      "alias": "intlMvpEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "intlMVP2022"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"intlMVP2022\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f6a9cae9488228d92a8e7bf4658b0691";

export default node;
